module.exports = __webpack_public_path__ + "img/duct_simple_corner.41e94e30.svg";